<footer class="dark:bg-gray-800 bg-white text-white shadow-md shadow-black py-4 bottom-0 absolute w-screen left-0 z-99">
    <div class="container mx-auto text-center dark:text-white text-black text-sm sm:text-md">
        <p>Copyright © 2024 - Stroomer. All rights reserved.</p>
    </div>
</footer>